'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Movie = void 0;
var $ = require("jquery");
var Movie = /** @class */ (function () {
    function Movie() {
        $('.trigViewMovie').click(function () {
            var movieTag = $(this).data("tag");
            $('#bulletViewPlayer').attr('src', 'https://www.youtube.com/embed/' + movieTag);
            $('.bulletViewMovie').show();
        });
        $('.trigCloseMovie').click(function (e) {
            if (!$.contains($('.paramMovieContent')[0], e.target)) {
                $('.bulletViewMovie').hide();
            }
        });
    }
    return Movie;
}());
exports.Movie = Movie;
exports.default = Movie;
